import * as AUDIO_TRACK from './constants/audioTrack';

/**
 * Legacy tracks support
 *
 * @param {string} label
 * @returns {string}
 */
export const getCorrectAudioTrackLabel = label => {
  const labelLower = (label || '').toLowerCase();

  switch (labelLower) {
    case AUDIO_TRACK.OV:
    case AUDIO_TRACK.QTZ:
    case AUDIO_TRACK.UND:
    case AUDIO_TRACK.QAA:
      return AUDIO_TRACK.OV;

    case AUDIO_TRACK.MIS:
    case AUDIO_TRACK.QAD:
      return AUDIO_TRACK.AD;

    default:
      return labelLower;
  }
};

export * as AUDIO_TRACK from './constants/audioTrack';
